import Vue from 'vue'
import Vuex from 'vuex'
import createMultiTabState from 'vuex-multi-tab-state'

import actions from './store/actions'
import state from './store/state'
import mutations from './store/mutations'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [
    createPersistedState({ key: 'logisticDriver' }),
    createMultiTabState()
  ]
})
